/***********************************************************************************************
 * Pipe to replace slashes with line breaks
 *
 * slash2br은 char2br과는 다르게 </a>안의 /는 <br />로 바꾸지 않는다.
 * 정확하게는 / 앞에 <가 있으면 변경을 무시한다.
 *
 * @file slash2br.pipe.ts
 * @module slash2brPipe
 * @category Pipe
 *
 * Copyright (c) 2023. 듣고 배우는 한국어 프로젝트.
 * by 박주형
 **********************************************************************************************/
import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'slash2br'
})
export class Slash2brPipe implements PipeTransform {

  transform(content: string | null | undefined): string | null {
    if (!content) return null;

    let result = '';
    for (let i = 0; i < content.length; i++) {
      if (content[i] === '/' && (i === 0 || content[i - 1] !== '<')) {
        result += '<br />';
      } else {
        result += content[i];
      }
    }
    return result;
  }

}
